export default __webpack_public_path__ + "static/media/info-outline.67a80959.svg";